import { gql } from '@/__generated__';

const UPDATE_DGA_MAX_FLOW = gql(`#graphql
  mutation UpdateDgaMaxFlow($deviceId: ID!, $maxFlow: Float) {
    updateDgaMaxFlow(deviceId: $deviceId, maxFlow: $maxFlow) {
      id
      dga {
        id
        configuration {
          id
          maxFlow
        }
      }
    }
  }
`);

export default UPDATE_DGA_MAX_FLOW;
